import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapmoms } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPMOMS: TIdToPageConfigMap = {
  [PageIdStylioCapmoms.AGE_CAPMOMS]: {
    id: PageIdStylioCapmoms.AGE_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapmoms.URGE_CAPMOMS]: {
    id: PageIdStylioCapmoms.URGE_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.HAIR_COLOR_CAPMOMS]: {
    id: PageIdStylioCapmoms.HAIR_COLOR_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.EYES_COLOR_CAPMOMS]: {
    id: PageIdStylioCapmoms.EYES_COLOR_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.JEWELRY_CAPMOMS]: {
    id: PageIdStylioCapmoms.JEWELRY_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.BODY_SHAPE_CAPMOMS]: {
    id: PageIdStylioCapmoms.BODY_SHAPE_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.STYLIO_TO_HELP_CAPMOMS]: {
    id: PageIdStylioCapmoms.STYLIO_TO_HELP_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.TALL_CAPMOMS]: {
    id: PageIdStylioCapmoms.TALL_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.WEIGHT_CAPMOMS]: {
    id: PageIdStylioCapmoms.WEIGHT_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.URGE_2_CAPMOMS]: {
    id: PageIdStylioCapmoms.URGE_2_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.FEEL_ABOUT_CAPMOMS]: {
    id: PageIdStylioCapmoms.FEEL_ABOUT_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.PERCENTAGE_CAPMOMS]: {
    id: PageIdStylioCapmoms.PERCENTAGE_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.SHOPPING_CAPMOMS]: {
    id: PageIdStylioCapmoms.SHOPPING_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.STYLE_MOST_MATTERS_CAPMOMS]: {
    id: PageIdStylioCapmoms.STYLE_MOST_MATTERS_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.FAVORITE_COLORS_CAPMOMS]: {
    id: PageIdStylioCapmoms.FAVORITE_COLORS_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_11_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_11_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_12_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_12_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_13_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_13_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_14_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_14_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_15_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_15_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_16_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_16_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_17_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_17_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_18_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_18_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.LIKE_OR_DISLIKE_19_CAPMOMS]: {
    id: PageIdStylioCapmoms.LIKE_OR_DISLIKE_19_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.STYLES_FEEL_LIKE_YOU_CAPMOMS]: {
    id: PageIdStylioCapmoms.STYLES_FEEL_LIKE_YOU_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.URGE_4_CAPMOMS]: {
    id: PageIdStylioCapmoms.URGE_4_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.TIME_CAPMOMS]: {
    id: PageIdStylioCapmoms.TIME_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.TYPICAL_DAY_CAPMOMS]: {
    id: PageIdStylioCapmoms.TYPICAL_DAY_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.YOUR_LOCATION_CAPMOMS]: {
    id: PageIdStylioCapmoms.YOUR_LOCATION_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.BRAND_CAPMOMS]: {
    id: PageIdStylioCapmoms.BRAND_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.FIND_NEW_CLOTHES_CAPMOMS]: {
    id: PageIdStylioCapmoms.FIND_NEW_CLOTHES_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.NOTHING_TO_WEAR_CAPMOMS]: {
    id: PageIdStylioCapmoms.NOTHING_TO_WEAR_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.OLD_CLOTHES_CAPMOMS]: {
    id: PageIdStylioCapmoms.OLD_CLOTHES_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.COMBINE_CLOTHES_CAPMOMS]: {
    id: PageIdStylioCapmoms.COMBINE_CLOTHES_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.OPTIMIZE_BUDGET_CAPMOMS]: {
    id: PageIdStylioCapmoms.OPTIMIZE_BUDGET_CAPMOMS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapmoms.URGE_3_CAPMOMS]: {
    id: PageIdStylioCapmoms.URGE_3_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.PREPARE_FLOW_CAPMOMS]: {
    id: PageIdStylioCapmoms.PREPARE_FLOW_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.EMAIL_CAPMOMS]: {
    id: PageIdStylioCapmoms.EMAIL_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.EMAIL_CONSENT_CAPMOMS]: {
    id: PageIdStylioCapmoms.EMAIL_CONSENT_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.PRE_PAYWALL_OFFER_CAPMOMS]: {
    id: PageIdStylioCapmoms.PRE_PAYWALL_OFFER_CAPMOMS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapmoms.SUBSCRIPTIONS_CAPMOMS]: {
    id: PageIdStylioCapmoms.SUBSCRIPTIONS_CAPMOMS,
  },
  [PageIdStylioCapmoms.CANCEL_OFFER_CAPMOMS]: {
    id: PageIdStylioCapmoms.CANCEL_OFFER_CAPMOMS,
  },
  [PageIdStylioCapmoms.SUB_UPSELL_CAPMOMS]: {
    id: PageIdStylioCapmoms.SUB_UPSELL_CAPMOMS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapmoms.UPSELL_CAPMOMS]: {
    id: PageIdStylioCapmoms.UPSELL_CAPMOMS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapmoms.DOWNLOAD_CAPMOMS]: {
    id: PageIdStylioCapmoms.DOWNLOAD_CAPMOMS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
